module.exports = __webpack_public_path__ + "img/anchor.f86e2418.png";